import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { logout } from 'redux/modules/auth';
import Divider from 'material-ui/Divider';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import { Avatar } from 'components';
var AvatarMenu = (_dec = connect(function (state, ownProps) {
  return {
    isLikeableUser: state.config.userType.isLikeableUser,
    user: state.auth.user,
    theme: state.theme
  };
}, {
  logout: logout
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AvatarMenu, _Component);

  var _super = _createSuper(AvatarMenu);

  function AvatarMenu() {
    _classCallCheck(this, AvatarMenu);

    return _super.apply(this, arguments);
  }

  _createClass(AvatarMenu, [{
    key: "render",
    value: function render() {
      var _this = this;

      var name = this.props.user ? "".concat(this.props.user.firstName, " ").concat(this.props.user.lastName) : '';
      var menuItems = [function (key) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: key,
          primaryText: name
        });
      }, function (key) {
        return /*#__PURE__*/React.createElement(Divider, {
          key: key
        });
      }, function (key) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: key,
          primaryText: "User Settings",
          onClick: function onClick() {
            return browserHistory.push({
              pathname: '/user/settings'
            });
          }
        });
      }, function (key) {
        return /*#__PURE__*/React.createElement(Divider, {
          key: key
        });
      }, function (key) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: key,
          primaryText: "Log Out",
          onClick: _this.props.logout
        });
      }].filter(function (o) {
        return o;
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconMenu, {
        style: {
          width: 56,
          "float": 'right',
          height: 48
        },
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'bottom'
        },
        iconButtonElement: /*#__PURE__*/React.createElement(IconButton, {
          style: {
            padding: 0,
            height: 48,
            width: 56
          }
        }, /*#__PURE__*/React.createElement(Avatar, {
          avatarStyle: {
            marginTop: 0
          },
          username: this.props.user ? name : '',
          imageUrl: this.props.user ? this.props.user.avatarUrl : ''
        }))
      }, menuItems.map(function (func, key) {
        return func(key);
      })));
    }
  }]);

  return AvatarMenu;
}(Component)) || _class);
export { AvatarMenu as default };